import { ISurveyResponse } from './interfaces/ISurveyResponse';
import { SurveyTypes } from '../services/SurveyService';
import { ICustomSurveyQuestion } from './interfaces/ICustomSurveyQuestion';

class SurveyUtils {
  static addDefaultNpsOptions(question: ICustomSurveyQuestion, t: (key: string) => string) {
    if (question.type !== 'CUSTOMSCALENPS') return;
    if (question.options?.length === 2) return;

    question.options = [{ label: t('nps_low') }, { label: t('nps_high') }];
  }
  static getPathByType(type: string) {
    switch (type) {
      case 'BAROMETER':
        return 'b';
      case 'NPS':
        return 'n';
      case 'STANDARD':
        return 's';
      case 'CUSTOMSURVEY':
        return 'c';
      default:
        return '';
    }
  }

  static getPublicUrl(type: string, slug: string) {
    return `${process.env.REACT_APP_FRONTEND_BASE_URL}/${SurveyUtils.getPathByType(type)}/${slug}`;
  }

  static getEndpointByType(type: string | undefined) {
    switch (type) {
      case 'BAROMETER':
        return 'trend';
      case 'NPS':
        return 'nps';
      case 'STANDARD':
        return 'standard';
      case 'CUSTOMSURVEY':
        return 'customsurvey';
      default:
        return '';
    }
  }

  static getTranslatableFieldsByType(type: string): {
    labelKey: string;
    field: string;
  }[] {
    /*
    Note: Only assume Customsurvey is complete
    */
    switch (type) {
      case 'BAROMETER':
        return [
          { labelKey: 'survey_name', field: 'label' },
          { labelKey: 'title', field: 'title' },
          { labelKey: 'intro', field: 'introText' },
          { labelKey: 'question', field: 'question' },
          { labelKey: 'positive', field: 'positiveText' },
          { labelKey: 'neutral', field: 'neutralText' },
          { labelKey: 'negative', field: 'negativeText' },
          { labelKey: 'comment_field_title', field: 'feedbackTitle' },

          { labelKey: 'outro', field: 'outroText' },
          { labelKey: 'outro_negative_nps', field: 'outroTextNegative' },
        ];
      case 'NPS':
        return [
          { labelKey: 'survey_name', field: 'label' },
          { labelKey: 'nps_survey', field: 'question' },
          { labelKey: 'comment_field_title', field: 'feedbackTitle' },
          { labelKey: 'comment_field', field: 'feedbackText' },
          { labelKey: 'scale0_label', field: 'scale.lowText' },
          { labelKey: 'scale10_label', field: 'scale.highText' },
          { labelKey: 'title', field: 'title' },
          { labelKey: 'outro', field: 'introText' },
          { labelKey: 'outro_negative_nps', field: 'introTextNegative' },
          { labelKey: 'signature', field: 'outroText' },
        ];
      case 'STANDARD':
        return [];
      case 'CUSTOMSURVEY':
        return [
          { labelKey: 'survey_name', field: 'label' },
          { labelKey: 'title', field: 'title' },
          { labelKey: 'intro', field: 'introText' },
          { labelKey: 'outro', field: 'outroText' },
          { labelKey: 'outro_negative', field: 'outroTextNegative' },
        ];
      default:
        return [];
    }
  }

  static getName(name: string | undefined) {
    if (name === 'GooglePlace') {
      return 'Google';
    }
    return name;
  }

  static isCompleted(answers: any[], questions: ISurveyResponse[]) {
    let oneIsGood = false;
    for (const question of questions) {
      if (false == question.optional) {
        const answer = answers.find((answer: any) => answer.questionId == question.id);
        if (!answer) {
          return false;
        }
      }
      oneIsGood = true;
    }
    return oneIsGood;
  }

  static getTypeName(type: string, t: any) {
    switch (type) {
      case 'NPS':
        return t('nps_survey');
      case 'STANDARD':
        return t('survey');
      case 'CUSTOMSURVEY':
        return t('custom_survey');
      case 'BAROMETER':
        return t('mood_barometer');
      default:
        return '';
    }
  }
}

export default SurveyUtils;
